import styled from 'styled-components';

export const InactiveBenefitsTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
  padding-bottom: 24px;
`;

export const ButtonSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 48px;
  padding-top: 16px;
  padding-right: 32px;
  padding-bottom: 0px;
  border-top: 1px solid ${({ theme }) => theme.altGray2};
  background-color: transparent;
  position: static; /* 👈 najważniejsze */
  box-sizing: border-box;

  button {
    min-width: 180px;
  }
`;

export const MyChoiceBottomInformation = styled.div`
  position: absolute;
  bottom: 36px;
`;
